/**
 * Эхний үлдэгдэл — системээс ӨМНӨ дэлгүүр, агуулахад байсан гутлыг
 * нэг удаа бүртгэх (2026-09, ~3000 ширхэг, Sunmi POS × 5).
 *
 * Гутал бүр дээр бизнесийн баркодтой шошго аль хэдийн наагдсан. Ажилтан
 * уншуулж, үнэ, зургийг л нэмнэ — нийлүүлэгч, размер, огноо баркодоос.
 *
 * ⚠️ Шошгон дээрх код НЬ серийн дугаар болно — шинээр олгохгүй, дахин
 *    хэвлэхгүй. Тиймээс баркодыг ЯГ байгаагаар нь хадгална.
 */
import { barcodeFullYear, normalizeSerialInput, parseBarcode } from './serial.js';
/** Эхний үлдэгдлийн аялалыг олох тэмдэг (`purchases.notes`). */
export const OPENING_PURCHASE_NOTE = 'Эхний үлдэгдэл';
/** Загвар нь мэдэгдэхгүй гутлын ерөнхий загвар (`product_models.code`) — эхний үлдэгдэл, бөөн бүртгэл. */
export const GENERIC_MODEL_CODE = 'GENERIC';
/** Размерын бодит хязгаар — `items` CHECK (infra/sql/002) ба `Size` схемтэй ижил. */
const SIZE_MIN = 20;
const SIZE_MAX = 60;
/**
 * Уншуулсан шошгыг шалгана. Сервер ба утас хоёулаа дуудна — утас нь
 * сүлжээ хүлээлгүйгээр буруу шошгыг шууд хэлнэ.
 */
export function readOpeningBarcode(raw, today) {
    const serial = normalizeSerialInput(raw);
    const parts = parseBarcode(serial);
    if (!parts) {
        return { ok: false, message: `«${serial}» — дэлгүүрийн 11–12 оронтой шошго биш` };
    }
    if (parts.size < SIZE_MIN || parts.size > SIZE_MAX) {
        return { ok: false, message: `Размер ${parts.size} — ${SIZE_MIN}–${SIZE_MAX} хооронд байх ёстой` };
    }
    const year = barcodeFullYear(parts.yearDigit, today);
    // УБ = UTC+8, зуны цаггүй. Шөнө дунд = өмнөх өдрийн 16:00 UTC.
    const collectedAt = new Date(Date.UTC(year, parts.month - 1, parts.day) - 8 * 3600_000);
    // 02-31 мэт огноог Date нь чимээгүй дараагийн сар руу шилжүүлдэг
    const back = new Date(collectedAt.getTime() + 8 * 3600_000);
    if (back.getUTCMonth() !== parts.month - 1 || back.getUTCDate() !== parts.day) {
        return { ok: false, message: `Огноо буруу: ${year}.${parts.month}.${parts.day}` };
    }
    if (collectedAt.getTime() > today.getTime()) {
        return { ok: false, message: `Шошгоны огноо ирээдүйд байна: ${year}.${parts.month}.${parts.day}` };
    }
    return { ok: true, serial, supplierPrefix: parts.supplierPrefix, size: parts.size, collectedAt };
}
//# sourceMappingURL=opening-stock.js.map